import { useDeselectOnEmptyClick } from 'hooks/useDeselectOnEmptyClick'
import { TIMELINE_PLUS_BUTTON_CLASS_NAME, TRACK_ITEM_CLASS_NAME } from 'consts'
import { TIMELINE_CONTENT_WRAPPER_ID } from './consts'

export const useDeselectTimelineItems = () =>
  useDeselectOnEmptyClick(TIMELINE_CONTENT_WRAPPER_ID, [
    TRACK_ITEM_CLASS_NAME,
    TIMELINE_PLUS_BUTTON_CLASS_NAME
  ])
